// extracted by mini-css-extract-plugin
module.exports = {"filterDotsWrapper":"customMenu_filterDotsWrapper__2NmLH","left":"customMenu_left__1jAm4","editDeleteWrapper":"customMenu_editDeleteWrapper__2sCqK"};